import './App.css';
import { Routes, Route } from "react-router-dom";
import MainLayout from './components/MainLayout';
import LandingPage from './components/LandingPage';
import ReservationPage from "./components/ReservationPage";
import MenuPage from './components/MenuPage';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminDashboard';
import Privacy from './components/Privacy';
import Cookie from './components/Cookie';
import Header from "./components/Header";
import Footer from "./components/Footer";
import AboutPage from "./components/AboutPage";
import NotFound from './components/NotFound';


function App() {
  return (
    <Routes>
      {/* Public Customer Routes wrapped in MainLayout */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="reservation" element={<ReservationPage />} />
      </Route>

      {/* Admin Login Route */}
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route path="/menu" element={ <MenuPage /> } />

      <Route path="/about" element={ 
      <>
        <Header />
        <AboutPage />
        <Footer />
      </> } />

      {/* Protected Admin Dashboard Route */}
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        } 
      />

      <Route 
        path='/privacy-policy'
        element={<>
        <Header />
        <Privacy />
        <Footer />
        </>}
      />

      <Route path="/cookie-policy" element={<>
        <Header />
        <Cookie />
        <Footer />
      </>} />

      {/* 404 No Page Found Catch-All Route */}
      <Route
          path="*"
          element={<NotFound />}
        />

    </Routes>
  );
}

export default App;
